import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom={
      backToTopBtn: this.el.querySelector('.back-to-top__button'),
      divTop: this.el
    }
  }

  addListeners() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.dom.backToTopBtn.addEventListener('click', this.handleClick.bind(this));
  }

  handleScroll(e) {
    if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
      this.dom.divTop.classList.add('back-to-top__display');
    } else {
      this.dom.divTop.classList.remove('back-to-top__display');
    }
  }

  handleClick(e) {
    document.body.scrollTo({ top:0, behavior: 'smooth' });
    document.documentElement.scrollTo({ top:0, behavior:'smooth' });
  }
}

export default Module;
